// Vendor libraries
import { ElementRef } from '@angular/core';
import { downloadUrlWrapper } from 'NewAngular/utils/download';
import { formatDate } from '@angular/common';
// Constants
import { PORTFOLIO_OPTIMIZER_DEFAULT_STATE, PORTFOLIO_OPTIMIZER_FREQUENCY_DROPDOWN_OPTIONS_LIST, } from 'PortfolioOptimizerApp/apps/portfolio-optimizer-app/state/constants';
// Enums / Interfaces
import { CorrelationMatrixSubTab } from 'PortfolioOptimizerApp/enums/correlation-matrix-tabs.enum';
import { OptimizerErrorCode, OptimizerFrequency } from 'PortfolioOptimizerApp/enums/portfolio-optimizer.enum';
// Services
import { PortfolioOptimizerService } from 'PortfolioOptimizerApp/services/portfolio-optimizer.service';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "PortfolioOptimizerApp/services/portfolio-optimizer.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../securities/static/securities/ts/features/comparables-modal/comparables-modal.component";
import * as i5 from "../correlation-matrix-heatmap/correlation-matrix-heatmap.component";
import * as i6 from "../../../../../../securities/static/securities/ts/features/edit-holdings-modal/edit-holdings-modal.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "NewAngular/features/components/modals/loading-modal/loading-modal.component";
import * as i9 from "../../../../../../securities/static/securities/ts/features/module-upsell/module-upsell.component";
import * as i10 from "../../apps/portfolio-optimizer-app/components/portfolio-optimizer-export-pdf-modal/portfolio-optimizer-export-pdf-modal.component";
import * as i11 from "../../../../../../../ycharts/static/ts/features/components/date-controls/single-date-picker/single-date-picker.component";
import * as i12 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ dropdownItem: "text-default" });
const _c1 = () => ({ button: "btn btn-block btn-secondary", dropdownItem: "text-default" });
const _c2 = a0 => ({ open: a0 });
const _c3 = a0 => ({ "disabled": a0 });
function CorrelationMatrixPageComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "button", 28);
    i0.ɵɵlistener("click", function CorrelationMatrixPageComponent_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const editHoldingsModal_r3 = i0.ɵɵreference(6); return i0.ɵɵresetView(editHoldingsModal_r3.openModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 29);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Edit Holdings");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "ycn-edit-holdings-modal", 30, 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("maxHoldings", 100)("maxDisplayHoldings", 100)("securityId", ctx_r3.securityId)("shouldReloadPage", true)("showRestoreDefaults", true);
} }
function CorrelationMatrixPageComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "button", 28);
    i0.ɵɵlistener("click", function CorrelationMatrixPageComponent_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const comparablesModal_r6 = i0.ɵɵreference(6); return i0.ɵɵresetView(comparablesModal_r6.openModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 29);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "ycn-comparables-modal", 31, 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Edit ", ctx_r3.activeTab == ctx_r3.HOLDINGS_SUBTAB ? "Holdings" : "Comparables", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("benchmarkSecurityId", ctx_r3.benchmarkSecurityId)("maxComparables", ctx_r3.maxComparables)("maxDisplayComparables", ctx_r3.maxDisplayComparables)("securityId", ctx_r3.securityId)("searchType", ctx_r3.relatedSecuritySearchType)("shouldReloadPage", true)("showRestoreDefaults", true)("modalText", ctx_r3.editComparablesModalText);
} }
function CorrelationMatrixPageComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32)(1, "h3", 33);
    i0.ɵɵtext(2, "Correlation Matrix");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 34)(4, "div", 35)(5, "div", 36)(6, "label", 37)(7, "input", 38);
    i0.ɵɵlistener("click", function CorrelationMatrixPageComponent_div_10_Template_input_click_7_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.toggleShowCorrelationData()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "span", 39);
    i0.ɵɵelementStart(9, "span", 40);
    i0.ɵɵtext(10, "Show Correlation Data");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(11, "div", 35)(12, "div", 41);
    i0.ɵɵlistener("click", function CorrelationMatrixPageComponent_div_10_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r7); i0.ɵɵnextContext(); const exportPDFModal_r8 = i0.ɵɵreference(29); return i0.ɵɵresetView(exportPDFModal_r8.openModal()); });
    i0.ɵɵtext(13, "Export");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("checked", ctx_r3.showCorrelationData);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, !ctx_r3.chartHasData));
} }
function CorrelationMatrixPageComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "label", 19);
    i0.ɵɵtext(2, "View Holdings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-single-select-dropdown", 20);
    i0.ɵɵlistener("changeHandler", function CorrelationMatrixPageComponent_div_22_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.holdingsChangeHandler($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("config", ctx_r3.holdingDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(3, _c1))("selectedValue", ctx_r3.holdings);
} }
function CorrelationMatrixPageComponent_ycn_correlation_matrix_heatmap_25_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-correlation-matrix-heatmap", 42);
    i0.ɵɵlistener("hasData", function CorrelationMatrixPageComponent_ycn_correlation_matrix_heatmap_25_Template_ycn_correlation_matrix_heatmap_hasData_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.chartHasData = $event); })("errorHandler", function CorrelationMatrixPageComponent_ycn_correlation_matrix_heatmap_25_Template_ycn_correlation_matrix_heatmap_errorHandler_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleError($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("chartDataUrl", ctx_r3.correlationMatrixDataUrl)("withCorrelationPoints", ctx_r3.showCorrelationData);
} }
function CorrelationMatrixPageComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43)(1, "div", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.errorMessage);
} }
export class CorrelationMatrixPageComponent {
    constructor(accountsService, eltRef, portfolioOptimizerService) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.portfolioOptimizerService = portfolioOptimizerService;
        this.showCorrelationData = false;
        this.chartHasData = false;
        this.defaultTitle = '';
        this.editComparablesModalText = '';
        this.errorMessage = '';
        this.exportLoading = false;
        this.exportError = '';
        this.errorModalIsOpen = false;
        this.maxComparables = 6;
        this.maxDisplayComparables = 6;
        this.HOLDINGS_SUBTAB = CorrelationMatrixSubTab.HOLDINGS;
        this.holdingDropdownConfig = {
            list: [
                { value: 'top_10', label: 'Top 10' },
                { value: 'top_25', label: 'Top 25' },
                { value: 'top_44', label: 'Top 44' },
                { value: 'top_100', label: 'Top 100' },
            ],
        };
        this.timeframeDropdownConfig = {
            list: [
                { label: '--', value: '' },
                { label: '1M', value: '1m' },
                { label: '3M', value: '3m' },
                { label: '6M', value: '6m' },
                { label: 'YTD', value: 'ytd' },
                { label: '1Y', value: '1y' },
                { label: '3Y', value: '3y' },
                { label: '5Y', value: '5y' },
                { label: '10Y', value: '10y' },
                { label: '15Y', value: '15y' },
            ],
        };
        this.frequencyDropdownConfig = {
            list: [...PORTFOLIO_OPTIMIZER_FREQUENCY_DROPDOWN_OPTIONS_LIST],
        };
        this.pdfWithCorrelationPoints = false;
        this.USER = window.USER;
        this.activeTab = eltRef.nativeElement.getAttribute('activeTab');
        this.name = eltRef.nativeElement.getAttribute('name');
        this.securityId = eltRef.nativeElement.getAttribute('securityId');
        this.benchmarkSecurityId = eltRef.nativeElement.getAttribute('benchmarkSecurityId');
        this.showCorrelationData = JSON.parse(eltRef.nativeElement.getAttribute('showCorrelationData'));
        this.pdfWithCorrelationPoints = this.showCorrelationData;
        this.userPreferenceKeys = JSON.parse(eltRef.nativeElement.getAttribute('userPreferenceKeys'));
        this.relatedSecuritySearchType = eltRef.nativeElement.getAttribute('relatedSecuritySearchType');
        this.securityIds = JSON.parse(eltRef.nativeElement.getAttribute('securityIds'));
        this.holdings = eltRef.nativeElement.getAttribute('holdings');
        this.timeframe = eltRef.nativeElement.getAttribute('timeframe') ?? '';
        this.frequency = eltRef.nativeElement.getAttribute('frequency');
        this.correlationMatrixTabUrl = eltRef.nativeElement.getAttribute('correlationMatrixTabUrl');
        this.endDate = new Date(eltRef.nativeElement.getAttribute('endDate'));
        const startDate = eltRef.nativeElement.getAttribute('startDate');
        if (startDate) {
            this.startDate = new Date(startDate);
        }
    }
    ngOnInit() {
        this.editComparablesModalText = `Drag and drop to reorder or search security to add. Only top 
         ${this.maxDisplayComparables} comparables are shown.`;
        this.defaultTitle =
            this.activeTab === CorrelationMatrixSubTab.HOLDINGS
                ? 'Holding Correlation Matrix'
                : 'Peer Correlation Matrix';
        if (this.securityIds && this.startDate && window.USER.authenticated) {
            this.correlationMatrixDataUrl = this.portfolioOptimizerService.getCorrelationMatrixURL({
                securityIds: this.securityIds,
                frequency: this.frequency,
                endDate: formatDate(this.endDate, 'M/d/yyyy', 'en-US'),
                startDate: formatDate(this.startDate, 'M/d/yyyy', 'en-US'),
            });
        }
        else {
            const comparables = this.activeTab === CorrelationMatrixSubTab.HOLDINGS ? 'holdings' : 'peers';
            this.errorMessage = `${this.name} does not have any ${comparables} selected. Please update.`;
        }
    }
    exportPdf(reportTitle) {
        this.exportLoading = true;
        const portfolioOptimizerState = {
            ...PORTFOLIO_OPTIMIZER_DEFAULT_STATE,
            frequency: this.frequency,
            endDate: formatDate(this.endDate, 'M/d/yyyy', 'en-US'),
            startDate: formatDate(this.startDate, 'M/d/yyyy', 'en-US'),
        };
        const maxSecurityIds = this.pdfWithCorrelationPoints ? 16 : 42;
        const fetchUrl = this.portfolioOptimizerService.getCorrelationMatrixPdfReportUrl(reportTitle, this.pdfWithCorrelationPoints, portfolioOptimizerState, this.securityIds.slice(0, maxSecurityIds));
        fetchUrl.subscribe({
            next: (response) => {
                // Set `onbeforeunload` to null to avoid triggering the "unsaved changes" warning when downloading
                // the PDF. After the download finishes, set the value back to the function set by
                // `SavedItemDropdownComponent` .
                window.onbeforeunload = null;
                downloadUrlWrapper(response.report_url).subscribe(() => {
                    this.exportLoading = false;
                });
            },
            error: (error) => {
                let errorMessage = 'There was an error exporting the portfolio optimizer. Please try again or contact support.';
                if (error.status === 400) {
                    errorMessage = error.error;
                }
                this.exportLoading = false;
                this.exportError = errorMessage;
                this.errorModalIsOpen = true;
            },
        });
    }
    handleError(error) {
        switch (error.code) {
            case OptimizerErrorCode.ZeroRiskHolding:
                this.errorMessage = 'A zero-risk security cannot be optimized. Please update.';
                break;
            case OptimizerErrorCode.ReturnsSparseForFreq:
                this.errorMessage = error.message;
                break;
            case OptimizerErrorCode.TargetReturnTooHigh:
                this.errorMessage =
                    'The target return is not achievable with the provided assets. Please update the target value.';
                break;
            case OptimizerErrorCode.TargetDeviationTooLow:
                this.errorMessage =
                    'The target standard deviation is not achievable with the provided assets. ' +
                        'Please update the target value.';
                break;
            case OptimizerErrorCode.InsufficientPeriods:
                this.errorMessage = 'Not enough return data to optimize the selected portfolio. Please update.';
                break;
            default:
                this.errorMessage = 'Unexpected error. Please re-try or contact support.';
        }
    }
    toggleShowCorrelationData() {
        this.showCorrelationData = !this.showCorrelationData;
        this.accountsService
            .putUserPreferences({ [this.userPreferenceKeys.show_correlation_data]: this.showCorrelationData })
            .subscribe(() => {
            window.location.reload();
        });
    }
    holdingsChangeHandler(holdings) {
        this.accountsService.putUserPreferences({ [this.userPreferenceKeys.holdings]: holdings }).subscribe(() => {
            window.location.reload();
        });
    }
    timeframeChangeHandler(timeframe) {
        window.location.href = `${window.location.origin}${window.location.pathname}?timeframe=${timeframe}`;
    }
    frequencyChangeHandler(frequency) {
        this.accountsService.putUserPreferences({ [this.userPreferenceKeys.frequency]: frequency }).subscribe(() => {
            window.location.reload();
        });
    }
    dateChangeHandler(date, type) {
        if (date) {
            if (type === 'startDate') {
                this.startDate = date;
            }
            else {
                this.endDate = date;
            }
            window.location.href = `${window.location.origin}${window.location.pathname}?startDate=${formatDate(this.startDate, 'M/d/yyyy', 'en-US')}&endDate=${formatDate(this.endDate, 'M/d/yyyy', 'en-US')}`;
        }
    }
}
CorrelationMatrixPageComponent.ɵfac = function CorrelationMatrixPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationMatrixPageComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.PortfolioOptimizerService)); };
CorrelationMatrixPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CorrelationMatrixPageComponent, selectors: [["ycn-correlation-matrix-page"]], inputs: { activeTab: "activeTab", name: "name", securityId: "securityId", benchmarkSecurityId: "benchmarkSecurityId", correlationMatrixTabUrl: "correlationMatrixTabUrl", holdings: "holdings", timeframe: "timeframe", frequency: "frequency", startDate: "startDate", endDate: "endDate", securityIds: "securityIds", relatedSecuritySearchType: "relatedSecuritySearchType", showCorrelationData: "showCorrelationData", userPreferenceKeys: "userPreferenceKeys" }, standalone: false, decls: 31, vars: 28, consts: [["exportPDFModal", ""], ["editHoldingsModal", ""], ["comparablesModal", ""], [1, "page-body"], [1, "tab-content"], [1, "tab-pane", "active", "ng-scope"], [1, "page-header"], [1, "page-title"], [1, "page-name"], ["class", "page-header-actions", 4, "ngIf"], [1, "panel", "panel-data"], ["class", "panel-header", 4, "ngIf"], [1, "panel-content"], [3, "title"], [1, "d-flex", "pt-1", "pb-1", "border-b", "border-color-gray-90"], [1, "d-flex", "align-items-center"], [1, "align-self-center", "mr-1", 3, "changeHandler", "config", "customCssClasses", "selectedValue"], [1, "dropdown", "width-90", "mr-1", 3, "dateChangeHandler", "appendToBody", "selectedDate"], [1, "d-flex", "align-items-center", "ml-auto"], [1, "form-label", "form-label-thin", "mr-1"], [3, "changeHandler", "config", "customCssClasses", "selectedValue"], ["class", "d-flex align-items-center ml-auto", 4, "ngIf"], [1, "matrix", "flex-auto", "pb-10", "mt-1", 2, "min-height", "300px"], [3, "chartDataUrl", "withCorrelationPoints", "hasData", "errorHandler", 4, "ngIf"], ["class", "toast toast-error", "style", "margin-top: 50pt", 4, "ngIf"], ["loadingText", "Exporting PDF", 3, "modalTrigger"], ["submitButtonText", "Download", 3, "withCorrelationPointsChange", "submitHandler", "defaultTitle", "maxTitleLength", "checkInvalidCharacters", "isCorrelationMatrix", "withCorrelationPoints"], [1, "page-header-actions"], [1, "btn", "btn-text", 3, "click"], ["ycnIcon", "", "name", "icon-edit"], [3, "maxHoldings", "maxDisplayHoldings", "securityId", "shouldReloadPage", "showRestoreDefaults"], [3, "benchmarkSecurityId", "maxComparables", "maxDisplayComparables", "securityId", "searchType", "shouldReloadPage", "showRestoreDefaults", "modalText"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [1, "page-header-action", "align-self-center", "mr-1"], [1, "custom-control", "custom-checkbox", "form-label", "form-label-thin"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "btn", "btn-text", 3, "click", "ngClass"], [3, "hasData", "errorHandler", "chartDataUrl", "withCorrelationPoints"], [1, "toast", "toast-error", 2, "margin-top", "50pt"], [1, "toast-text"]], template: function CorrelationMatrixPageComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "div", 7)(5, "div", 8);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(7, CorrelationMatrixPageComponent_div_7_Template, 7, 5, "div", 9)(8, CorrelationMatrixPageComponent_div_8_Template, 7, 9, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 10);
        i0.ɵɵtemplate(10, CorrelationMatrixPageComponent_div_10_Template, 14, 4, "div", 11);
        i0.ɵɵelementStart(11, "div", 12);
        i0.ɵɵelement(12, "ycn-module-upsell", 13);
        i0.ɵɵelementStart(13, "div", 14)(14, "div", 15)(15, "ycn-single-select-dropdown", 16);
        i0.ɵɵlistener("changeHandler", function CorrelationMatrixPageComponent_Template_ycn_single_select_dropdown_changeHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.frequencyChangeHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "ycn-single-date-picker", 17);
        i0.ɵɵlistener("dateChangeHandler", function CorrelationMatrixPageComponent_Template_ycn_single_date_picker_dateChangeHandler_16_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateChangeHandler($event, "startDate")); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "ycn-single-date-picker", 17);
        i0.ɵɵlistener("dateChangeHandler", function CorrelationMatrixPageComponent_Template_ycn_single_date_picker_dateChangeHandler_17_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateChangeHandler($event, "endDate")); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 18)(19, "label", 19);
        i0.ɵɵtext(20, "View Timeframe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "ycn-single-select-dropdown", 20);
        i0.ɵɵlistener("changeHandler", function CorrelationMatrixPageComponent_Template_ycn_single_select_dropdown_changeHandler_21_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.timeframeChangeHandler($event)); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(22, CorrelationMatrixPageComponent_div_22_Template, 4, 4, "div", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 22)(24, "div", 12);
        i0.ɵɵtemplate(25, CorrelationMatrixPageComponent_ycn_correlation_matrix_heatmap_25_Template, 1, 2, "ycn-correlation-matrix-heatmap", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, CorrelationMatrixPageComponent_div_26_Template, 3, 1, "div", 24);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelement(27, "ycn-loading-modal", 25);
        i0.ɵɵelementStart(28, "ycn-portfolio-optimizer-export-pdf-modal", 26, 0);
        i0.ɵɵtwoWayListener("withCorrelationPointsChange", function CorrelationMatrixPageComponent_Template_ycn_portfolio_optimizer_export_pdf_modal_withCorrelationPointsChange_28_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.pdfWithCorrelationPoints, $event) || (ctx.pdfWithCorrelationPoints = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵlistener("submitHandler", function CorrelationMatrixPageComponent_Template_ycn_portfolio_optimizer_export_pdf_modal_submitHandler_28_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exportPdf($event)); });
        i0.ɵɵtext(30, "\n>");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1("", ctx.name, " Correlation");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.activeTab == ctx.HOLDINGS_SUBTAB && ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.activeTab != ctx.HOLDINGS_SUBTAB && ctx.USER.authenticated);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", "Correlation Matrix");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("config", ctx.frequencyDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(24, _c0))("selectedValue", ctx.frequency);
        i0.ɵɵadvance();
        i0.ɵɵproperty("appendToBody", true)("selectedDate", ctx.startDate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("appendToBody", true)("selectedDate", ctx.endDate);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("config", ctx.timeframeDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(25, _c1))("selectedValue", ctx.timeframe);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.activeTab == ctx.HOLDINGS_SUBTAB);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("modalTrigger", i0.ɵɵpureFunction1(26, _c2, ctx.exportLoading));
        i0.ɵɵadvance();
        i0.ɵɵproperty("defaultTitle", ctx.defaultTitle)("maxTitleLength", 95)("checkInvalidCharacters", false)("isCorrelationMatrix", true);
        i0.ɵɵtwoWayProperty("withCorrelationPoints", ctx.pdfWithCorrelationPoints);
    } }, dependencies: [i3.NgClass, i3.NgIf, i4.ComparablesModalComponent, i5.CorrelationMatrixHeatmapComponent, i6.EditHoldingsModalComponent, i7.IconDirective, i8.LoadingModalComponent, i9.ModuleUpsellComponent, i10.PortfolioOptimizerExportPDFModalComponent, i11.SingleDatePickerComponent, i12.SingleSelectDropdownComponent], encapsulation: 2 });
